<template>
  <div class="pageDialog" v-if="hideContainer">
    <div
      class="dialogContainer"
      :class="
        showDialog
          ? 'animate__animated animate__zoomInDown'
          : 'animate__animated animate__zoomOutDown'
      "
    >
      <div class="dialogHeader">
        <span class="dialogTitle">
          <img class="dialogTitleIcon" :src="title.icon" @click="close" />
          <span>{{ $t(`tools.toolsInfo.${title.title}`) }}</span>
        </span>
        <img class="closeIcon" src="@img/ico_clos@2x.png" @click="close" />
      </div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number | String,
    },
    title: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    showDialog(val) {
      if (!val) {
        setTimeout(() => {
          this.hideContainer = val;
        }, 600);
      } else {
        this.hideContainer = val;
      }
    },
  },
  data() {
    return {
      hideContainer: false,
      showDialog: false,
    };
  },
  methods: {
    close() {
      this.showDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
.pageDialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 991;
  .dialogContainer {
    width: 1200px;
    border-radius: 16px;
    overflow: hidden;
    .dialogHeader {
      padding: 0 32px;
      height: 48px;
      display: flex;
      align-items: center;
      background: #457dfb;
      .dialogTitle {
        margin-right: auto;
        display: inline-flex;
        align-items: center;
        .dialogTitleIcon {
          width: 40px;
          height: 40px;
        }
        span {
          font-size: 22px;
          color: #ffffff;
        }
      }
      .closeIcon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
    .content {
      padding: 40px 32px 30px 32px;
      background: #fff;
    }
  }
}
</style>

<style lang="less">
.animate__animated.animate__zoomInDown {
  --animate-duration: 0.6s;
}
.animate__animated.animate__zoomOutDown {
  --animate-duration: 0.6s;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue